<template>
    <div>
        <div class="box" v-if="show">
            <!-- 头部 -->
            <div class="hard">
                <div class="minbox">
                    <div class="withdraw">可提现佣金</div>
                    <div class="price">{{wallet_info.cash_num}}</div>
                </div>
                <div class="minbox w">
                    <div class="withdraw">累计佣金</div>
                    <div class="price">{{wallet_info.total_income}}</div>
                </div>
                <div class="minbox">
                    <el-button @click="show = false">我要提现</el-button>
                </div>
            </div>
            <!-- 我的推广的用户 -->
            <div class="user">我的推广的用户（{{total}}）</div>

            <div class="table">
                <el-table :data="user_list" style="width: 100%">
                    <el-table-column label="头像">
                        <template slot-scope="scope">
                            <img :src="scope.row.head_img" class="user-img"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="nick_name" label="昵称"></el-table-column>
                    <el-table-column prop="add_time" label="推广时间"></el-table-column>
                </el-table>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageIndex"
                        :page-size="6"
                        background layout="prev, pager, next" :total="total"></el-pagination>
            </div>
        </div>
        <div class="box" v-else>
            <div class="hards">
                <div class="money">
                  <span>输入提现金额</span>
                  <span>手续费：{{wallet_info.cash_fees*100}}%</span>
                </div>
                <div>
                    <span class="q">¥</span>
                    <input type="number" :placeholder="'满'+wallet_info.start_num+'方可提现'" v-model="withdraw_price" :max="wallet_info.cash_num"
                           @input="change_price"
                           min="0"/>
                </div>
                <div class="ke">
                  <div>
                    <span>可提现佣金 </span>
                    <span>￥{{wallet_info.cash_num}} </span>
                    <span class="all" @click="all_cash">全部提现</span>
                  </div>
                  <div>
                    <span>实际到账金额：</span><span class="all">{{prices}}</span>
                  </div>
                </div>
            </div>
            <div class="arrive">
                <div class="arrive-left">
                    <span class="dao">提现到</span>
                </div>
                <div class="arrive-right">
                    <img src="@/assets/wx.png" alt="" class="wx-icon">
                    <span class="wx">微信</span>
                </div>
            </div>
            <el-button class="Btn2" @click="cash">确认提现</el-button>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        show: true,
        // 推广列表
        user_list: [],
        pageIndex: 1,
        total: 0,
        // 我的钱包
        wallet_info: {
          cash_num: '0.00'
        },
        withdraw_price: '',
        // 支付类型
        record_type: 1
      }
    },
    computed: {
      prices: function () {
        let num = this.withdraw_price*this.wallet_info.cash_fees
        num = this.withdraw_price - num
        return num.toFixed(2)
      }
    },
    mounted () {
      this.get_money()
      this.get_list()
    },
    methods: {
      change_price () {
        if (this.withdraw_price.indexOf('-') != -1) {
          this.withdraw_price = ''
        } else {
          if (this.withdraw_price < 1) {
            this.$nextTick(() => {
              this.withdraw_price = ''
            })
          }
        }
        if (this.withdraw_price.split('.')[1] && this.withdraw_price.split('.')[1].length > 2) {
          let num = this.withdraw_price
          num = num.toString()
          let index = num.indexOf('.')
          if (index !== -1) {
            num = num.substring(0, 2 + index + 1)
          } else {
            num = num.substring(0)
          }
          this.$nextTick(() => {
            this.withdraw_price = parseFloat(num).toFixed(2)
          })
        }
      },
      get_money () { // 我的钱包
        this.API.post('user/user_infos-my_wallet', {}).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.wallet_info = res.data.wallet_info
        })
      },
      all_cash () { // 全部提现
        this.withdraw_price = this.wallet_info.cash_num
      },
      cash () { // 确认提现
        if (!this.withdraw_price) {
          return this.$message({
            showClose: true,
            message: '请输入正确的提现金额',
            type: 'error',
          })
        }
        if (this.withdraw_price <= this.wallet_info.cash_num) {
          this.API.post('user/user_infos-cash_out', {
            money: this.withdraw_price,
            record_type: this.record_type // 支付类型 1.微信 2.支付宝
          }).then((res) => {
            if (res.errno != 0) {
              return this.API.SMessage(res.message)
            }
            this.show = true
            this.$message({
              showClose: true,
              message: '提现成功',
              type: 'success',
            })
            this.withdraw_price = ''
          })

        } else {
          this.$message({
            showClose: true,
            message: '提现金额不能大于可提现金额',
            type: 'error',
          })
        }
      },
      get_list () { // 我推广的用户
        this.API.post('user/user_infos-invite_list', {
          page_size: 6,
          page: this.pageIndex
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.total = res.data.cnt_user
          this.user_list = res.data.user_list
        })
      },
      handleSizeChange (val) { // 每页条数操作
        this.pageIndex = 1
        this.get_list()
      },
      handleCurrentChange (val) { // 页数操作
        this.pageIndex = val
        this.get_list()
      },
    }
  }
</script>

<style lang="less" scoped>
    .user-img {
        width: 43px;
        height: 43px;
        min-width: 43px;
        border-radius: 50%;
    }

    .box {
        width: 960px;
        height: 940px;
        margin-bottom: 20px;
    }

    .hard {
        display: flex;
        justify-content: center;
        position: relative;
        left: 50%;
        top: 28px;
        transform: translate(-50%);
        width: 920px;
        height: 188px;
        background: #ffffff;
        border: 1px solid #dcdcdc;

        .w {
            border-right: 1px solid #ccc;
        }

        .minbox {
            text-align: center;
            line-height: 188px;
            flex: 1;

            .withdraw {
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
                line-height: 125px;
            }

            .price {
                font-size: 36px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #e9511b;
                line-height: 0px;
            }

            .el-button {
                width: 158px;
                height: 60px;
                background: #f9f7f5;
                border: 1px solid #e9511b;
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #e9511b;
                line-height: 36px;
            }
        }
    }

    .user {
        height: 21px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        line-height: 36px;
        margin: 43px 0 26px 20px;
    }

    .table {
        margin-left: 20px;
    }

    .el-pagination {
        margin-top: 30px;
        text-align: center;
    }

    .hards {
        position: relative;
        left: 50%;
        top: 28px;
        transform: translate(-50%);
        width: 920px;
        height: 220px;
        border: 1px solid #dcdcdc;

        > div {
            margin-left: 20px;

            .q {
                width: 26px;
                height: 37px;
                font-size: 48px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                line-height: 70px;
            }

            input {
                width: 360px;
                height: 50px;
                font-size: 50px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                border: 0;
                margin-left: 20px;
            }

            span {
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }

            .all {
                color: #2aa9b5;
            }
        }

        .ke {
            padding-right: 20px;
            margin-top: 40px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        .money {
            padding-right: 20px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            line-height: 70px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    .arrive {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        left: 50%;
        top: 50px;
        transform: translate(-50%);
        width: 920px;
        height: 77px;
        background: #ffffff;
        border: 1px solid #dcdcdc;

        .dao {
            line-height: 77px;
            margin-left: 20px;
        }

        .wx-icon {
            width: 30px;
            height: 29px;
            margin-right: 10px;
        }

        .img {
            width: 30px;
            height: 29px;
            float: right;
        }

        .wx {
            line-height: 77px;
            margin-right: 20px;
        }

        .arrive-right {
            display: flex;
            align-items: center;
        }
    }

    .Btn2 {
        position: relative;
        top: 100px;
        left: 785px;
        width: 158px;
        height: 60px;
        background: #f9f7f5;
        border: 1px solid #e9511b;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #e9511b;
        line-height: 36px;
    }
</style>
